var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1602 31.8879V35.6942C20.1602 38.9192 17.1602 41.5254 13.4664 41.5254C9.77266 41.5254 6.75391 38.9192 6.75391 35.6942V31.8879C6.75391 35.1129 9.75391 37.4004 13.4664 37.4004C17.1602 37.4004 20.1602 35.0942 20.1602 31.8879Z",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1555 26.7317C20.1555 27.6692 19.893 28.5317 19.443 29.2817C18.3367 31.1004 16.068 32.2442 13.443 32.2442C10.818 32.2442 8.54922 31.0817 7.44297 29.2817C6.99297 28.5317 6.73047 27.6692 6.73047 26.7317C6.73047 25.1192 7.48047 23.6754 8.68047 22.6254C9.89922 21.5567 11.568 20.9192 13.4242 20.9192C15.2805 20.9192 16.9492 21.5754 18.168 22.6254C19.4055 23.6567 20.1555 25.1192 20.1555 26.7317Z",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1602 26.7316V31.8879C20.1602 35.1129 17.1602 37.4004 13.4664 37.4004C9.77266 37.4004 6.75391 35.0941 6.75391 31.8879V26.7316C6.75391 23.5066 9.75391 20.9004 13.4664 20.9004C15.3227 20.9004 16.9914 21.5566 18.2102 22.6066C19.4102 23.6566 20.1602 25.1191 20.1602 26.7316ZM41.2502 20.8441V24.7066C41.2502 25.7379 40.4252 26.5816 39.3752 26.6191H35.7002C33.6752 26.6191 31.8189 25.1379 31.6502 23.1129C31.5377 21.9316 31.9877 20.8254 32.7752 20.0566C33.4689 19.3441 34.4252 18.9316 35.4752 18.9316H39.3752C40.4252 18.9691 41.2502 19.8129 41.2502 20.8441Z",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 19.9629V16.2129C3.75 11.1129 6.825 7.55039 11.6063 6.95039C12.0938 6.87539 12.6 6.83789 13.125 6.83789H30C30.4875 6.83789 30.9563 6.85664 31.4062 6.93164C36.2437 7.49414 39.375 11.0754 39.375 16.2129V18.9316H35.475C34.425 18.9316 33.4687 19.3441 32.775 20.0566C31.9875 20.8254 31.5375 21.9316 31.65 23.1129C31.8187 25.1379 33.675 26.6191 35.7 26.6191H39.375V29.3379C39.375 34.9629 35.625 38.7129 30 38.7129H25.3125",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulation);
export default __webpack_public_path__ + "static/media/simulation.95f752bc22544d074ba6de5f69c89f0a.svg";
export { ForwardRef as ReactComponent };